<template>
    <div class="contanier">
        我的页面
    </div>
</template>
<script>
export default {
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {
        // 获取所有的Cookie
       
    }
}
</script>


<style lang="less" scoped>
@import '../../assets/variables.less';


</style> 